import React from "react";
import "./Hakkimizda.css";

export default function Hakkimizda() {
  return (
    <div className="hakkimizda-container">
      <div className="hakkimizda-content">
        <h1 className="hakkimizda-title">190 Tıbbiyeli Dergisi</h1>
        
        <div className="hakkimizda-text">
          <p>
            190 Tıbbiyeli, adını 1911 yılında memleketin kurtuluşu için omuz omuza mücadele eden 190 Tıbbiye öğrencisinden alır. Bu isim, sadece bir sayı değil; fedakârlığın, idealizmin ve vatan sevgisinin sembolüdür. Bizler de bu ruhla yola çıkmış, hekimlerden ve Tıp Fakültesi öğrencilerinden oluşan bir fikir ve yayın hareketiyiz.
          </p>
          
          <p>
            2017 yılında, İsmail Bey Gaspıralı'nın "Dilde, Fikirde, İşte Birlik" parolasıyla neşet eden dergimiz; köklerini medeniyetimizin düşünce damarlarından alır. Ziya Gökalp'in ilmi duruşu, Hüseyin Nihal Atsız'ın karakteri, Erol Güngör'ün derinliği ve Galip Erdem'in fikri zarafeti; kalemimize yön veren kutup yıldızlarımız olmuştur.
          </p>
          
          <p>
            Tıp eğitimi gibi yoğun bir alanda, düşünce dünyamıza nefes aldırmayı, entelektüel üretime katkı sunmayı ve çağın meselelerine hekim sorumluluğuyla bakmayı görev addediyoruz. Yazılarımızda yalnızca tıbbi bilgiye değil; tarih, felsefe, sosyoloji ve kültüre de yer veriyor; çok yönlü bir fikir dünyasını beslemeyi amaçlıyoruz.
          </p>
          
          <p>
            190 Tıbbiyeli, bir dergiden fazlasıdır. Aynı ideale baş koymuş genç hekimlerin, ilim ve irfan meşalesini elden ele taşıdığı bir okuldur. Hem tıbbi hem fikri anlamda sahici bir duruşun, kaliteli üretimin ve düşünsel bütünlüğün peşindeyiz.
          </p>
          
          <p>
            Bugün, dün olduğu gibi, "vatan için fikir üretmek" gayesiyle yazıyor; bunun için muhtaç olduğumuz kudretin ise damarlarımızdaki asil kanda olduğunu biliyoruz.
          </p>
        </div>
      </div>
    </div>
  );
} 